module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"organizations":"@:labels.organizations","title":"@:labels.overview"},"fr":{"organizations":"@:labels.organizations","title":"@:labels.overview"}}')
  delete Component.options._Ctor
}
